import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getStartedPage } from './get-started.type';
import { fetchCities, postCreateUnverifiedLead } from './get-started.model';

const initialState: getStartedPage ={
    loadingCities: false,
    errorLoadingCities: false,
    cities: [],
    submitting: false
}
const getStartedSlice = createSlice({
    name:"getStarted",
    initialState,
    reducers:{
        setSubmitting: (state, action:PayloadAction<getStartedPage["submitting"]> )=>{
            state.submitting= action.payload
        }
    },
    extraReducers:(builder)=> {
        builder.addCase(fetchCities.pending,(state)=>{
            state.loadingCities = true;
            state.errorLoadingCities = false;
        });
        builder.addCase(fetchCities.fulfilled,(state, action)=>{
            state.loadingCities = false;
            if (action.payload === "error") {
                state.errorLoadingCities = true;
                state.cities = [];
                
            } else {
                state.errorLoadingCities = false;
                state.cities = action.payload;
            }
        });
        builder.addCase( postCreateUnverifiedLead.pending,(state)=>{
            state.submitting = true;
        });
        builder.addCase(postCreateUnverifiedLead.fulfilled,(state,action)=>{
            state.submitting = false;            
        });
    },
});
export const {setSubmitting} = getStartedSlice.actions;
export const getStartedReducer = getStartedSlice.reducer;
export default getStartedSlice;